import { render, staticRenderFns } from "./kcjs1-2.vue?vue&type=template&id=6fb73f47&scoped=true&"
import script from "./kcjs1-2.vue?vue&type=script&lang=js&"
export * from "./kcjs1-2.vue?vue&type=script&lang=js&"
import style0 from "./kcjs1-2.vue?vue&type=style&index=0&id=6fb73f47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb73f47",
  null
  
)

export default component.exports